/** WebSocket protocol between client and game server. */
import { z } from 'zod';
import { ActionSchema, type GameEvent, type GameView } from './game.js';
import { EMOTES } from './econ.js';

export const ClientMessage = z.discriminatedUnion('type', [
  z.object({ type: z.literal('join'), matchId: z.string().uuid() }),
  z.object({ type: z.literal('leave'), matchId: z.string().uuid() }),
  z.object({ type: z.literal('act'), matchId: z.string().uuid(), seq: z.number().int(), action: ActionSchema }),
  z.object({ type: z.literal('emote'), matchId: z.string().uuid(), emote: z.enum(EMOTES.map((e) => e.id) as [string, ...string[]]) }),
  z.object({ type: z.literal('auto'), matchId: z.string().uuid(), on: z.boolean() }),
  z.object({ type: z.literal('forfeit'), matchId: z.string().uuid() }),
  z.object({ type: z.literal('queue'), mode: z.enum(['1v1', '2v2']), on: z.boolean() }),
  z.object({ type: z.literal('ping') }),
]);
export type ClientMessage = z.infer<typeof ClientMessage>;

export type ServerMessage =
  | { type: 'hello'; userId: string }
  | { type: 'state'; matchId: string; view: GameView; events: GameEvent[]; serverNow?: number }
  | { type: 'error'; matchId?: string; message: string }
  | { type: 'emote'; matchId: string; player: number; emote: string }
  | { type: 'presence'; matchId: string; connected: boolean[] }
  | { type: 'result'; matchId: string; rewards: MatchRewards }
  | { type: 'queued'; mode: '1v1' | '2v2'; position: number }
  | { type: 'match_found'; matchId: string }
  | { type: 'challenge'; from: { id: string; username: string; display_name: string; avatar: string }; matchId: string }
  | { type: 'notify'; text: string; href?: string }
  | { type: 'pong' };

export interface MatchRewards {
  won: boolean;
  credits: number;
  xp: number;
  kills: number;
  tames: number;
  turns: number;
  missions: { id: string; name: string; progress: number; target: number; done: boolean }[];
  ratingDelta?: number;
}
